const CheckSupportedBrowser =  () => {
  const userAgent = navigator.userAgent;

  if(userAgent.match(/chrome|chromium|crios/i) || userAgent.match(/opr\//i) || userAgent.match(/edg/i)){
    return true;
  }

  return false;
}

export default CheckSupportedBrowser;
